<template>
  <div class="newsletter">
    <div class="mobile-title" v-if="!side">
      <p class="title-p-1">Sign up to newsletter</p>
    </div>
    <form v-on:submit.prevent="subscribe" class="newsletter" v-if="!success && !error">
      <div class="newsletter-content">
        <div class="checkbox-wrapper">
          <div :class="['input-checkbox', checkbox_error && 'error']">
            <input type="checkbox" id="check"/>
            <label for="check" style="--d: 20px;">
              <svg viewBox="0,0,50,50">
                <path d="M5 30 L 20 45 L 45 5"></path>
              </svg>
            </label>            
          </div>
          <p>
              I accept YIS’s
              <router-link to="/privacy-policy/">Privacy Policy.</router-link>
          </p>         
          <span :class="['checkbox-error', checkbox_error && 'error']">{{checkbox_error}}</span>
        </div>        
        <div :class="['input-wrapper', email_error && 'error']">
          <div class="input-email">
            <input type="text" class="subscribe-email" placeholder="Your email:" v-model="email" />
          </div>         
          <span :class="['email-error', email_error && 'error']">{{email_error}}</span>       
        </div>
        <p class="newsletter-p-1">The Design Essentials You Need</p>
        <p class="newsletter-p-2">all in your inbox</p>
        <div class="submit">
          <button type="submit">GET IT</button>
        </div>
      </div>
    </form>
    <div class="newsletter-info-text" v-if="success">
      <div class="info">Your email has been added to the newsletter list.</div>
    </div>
    <div class="newsletter-info-text error" v-if="error">
      <div class="info">{{error}}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Newsletter",
  data: () => ({
    email: "",
    success: false,
    error: false,
    checkbox_error: null,
    email_error: null
  }),
  props: {
     side: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    async subscribe() {
      if (this.email.trim().length > 2 && this.validateEmail(this.email) && this.validateCheckbox()) {
        try {
          const res = await axios.post("/mailchimp.php", {
            email: this.email
          });
          if (res && res.data && res.data.status !== 400) {
            this.email = "";
            this.success = true;
            this.error = false;
          } else {
            this.email = "";
            this.success = false;
            this.error = "Member Exists.";
          }
        } catch (error) {
          this.email = "";
          this.success = false;
          this.error = "A problem occurred. Please try again later.";
        }
      } 
      if(!this.validateEmail(this.email)) {
        this.email_error = "Incorrect email address.";
      }else{
        this.email_error = null;
      }
      if (!this.validateCheckbox()){
         this.checkbox_error = "Please, accept privacy policy.";
      }
    },
    validateCheckbox() {
      if (document.getElementById('check').checked) {
        this.checkbox_error = null;
        return true;
      }else{
        return false;
      }      
    }
  }
};
</script>

<style lang="scss">
.newsletter {
  max-width: 420px;
  margin: 0 auto;
  .mobile-title{
    .title-p-1{
      text-transform: uppercase;
      font-size: 30px;
    }
  }
  .newsletter-content {
    padding: 50px 0;
    .checkbox-wrapper{
      .checkbox-error {
        display: block;
        position: absolute;
        width: calc(100% - 50px);    
        @include opensans-light;
        font-size: 14px;
        line-height: 14px;
        color: $red;
      }
      p{
        display: inline-block;
        width: 90%;
        padding-left: 10px;
      }
      .input-checkbox{
        margin-top: 2px;
        display: block;
        width: 20px;
        height: 20px;
        float: left; 
        &.error{
          input#check + label  {
              border: 1px solid red;
            }        
          
        }
        input#check {
          display: none;
          position: absolute;
          opacity: 0;  
          width: 20px; 
          height: 20px;
          &:checked + label svg path {
            stroke-dashoffset: 0;            
          }
          &:checked + label  {
            border: 1px solid $pink;
          }        
        }
        #check + label {         
          display: block;
          width: 80%;          
          border: 1px solid rgb(255, 255, 255);
          width: 20px; 
          height: 20px;
          cursor: pointer;
          transition: border 0.3s;
          &:active {
            border: 1px solid rgb(124, 52, 52);
          }
          &:hover{
            border: 1px solid $pink;
          }
          svg {
            pointer-events: none;
            path {			
              fill: none;			
              stroke: $pink;
              stroke-width: 5px;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-dasharray: 70;
              stroke-dashoffset: 71;
              transition: all 300ms cubic-bezier(1,0,.37,.91);
            }
          }
        }
      }
    }
    .newsletter-p-1{
      text-transform: uppercase;
      text-align: center;
      font-size: 24px;
    }
    .newsletter-p-2{
      text-align: center;
      font-size: 20px;
      line-height: 1.6em;
    }
    .input-wrapper {
      margin: 50px 0;
      &.error {
         .input-email {        
        &:after {         
          background:red;
        }
      }
      }
      .input-email {
        position: relative;
        .subscribe-email {
          display: block;
          width: 100%;
          @include opensans-light;
          font-size: 18px;
          line-height: 40px;
          height: 40px;
          color: $white;
          background: none;
          border: none;
          &::placeholder {
            color: rgba(255, 255, 255, 0.15);
          }
        }
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background: $white;
          transition: background 0.3s;
        }
      }
      .email-error {
        // @include opensans-light;
        // font-size: 14px;
        // line-height: 14px;
        // color: $red;
        display: block;
        position: absolute;
        width: 50%;    
        @include opensans-light;
        font-size: 14px;
        line-height: 14px;
        color: $red;
      }
    }
    .submit {
      margin-top: 50px;
      text-align: right;
    }
    button {
      position: relative;
      @include josefinsans-light;
      font-size: 32px;
      line-height: 38px;
      color: $white;
      background: none;
      border: none;
      text-transform: uppercase;
      cursor: pointer;
      background-image: linear-gradient(currentColor, currentColor);
      background-position: 0% 100%;
      background-repeat: no-repeat;
      background-size: 0% 2px;
      transition: all 0.3s !important;
      &:hover {
        color: $pink;
        background-size: 100% 2px;
        &:before {
          background: $pink;
        }
      }
      &:before {
        content: "";
        position: absolute;
        right: 100%;
        top: 50%;
        margin-top: -0.5px;
        margin-right: 20px;
        width: 20px;
        height: 1px;
        background: $white;
        transition: background 0.5s;
      }
    }
  }
  .newsletter-info-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 388px;
    text-align: center;
    &.error {
      .info {
        color: $red;
      }
    }
    .info {
      font-size: 18px;
      line-height: 24px;
    }
  }
}

@media (max-width: $tablet) {
  
  .newsletter {
    .mobile-title {
      display: block;
      .title-p-1{
        font-size: 26px;
      }
    }
    .newsletter-content {
      padding: 50px 0;
      .checkbox-wrapper{
        .input-checkbox{
          margin-top: 0px;
        }
      }
      .newsletter-p-1{     
         font-size: 26px;
      }
    }
  }
}
@media (max-width: $mobile) {
.newsletter {
  .mobile-title {      
      .title-p-1{
        font-size: 20px;
      }
    }
    .newsletter-content {
      button {
        font-size: 20px;
        line-height: 18px;
      }      
      .newsletter-p-2{
        font-size: 16px;
      }
      .newsletter-p-1{      
        font-size: 20px;
      }
      
    }
  }
}
</style>